import {types} from './types';

const initialState = {
    list: [],
}

export function currencyReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_CURRENCY:
            return { ...state, list: action.payload};
        default:
            return state
    }
}